module.exports = __webpack_public_path__ + "img/ng.48d37958.svg";